/* eslint-disable */
/* This file is auto-generated. Do not edit this file directly. */

/*
 * This file contains an index of all the routes in the app. It can help to
 * catch broken links at build time. If a route is moved or removed, any
 * references to its original key in this file will raise an error.
 */

export const drawers = {
  CompanySummary: '/companies/:companyName',
  CreateNetwork: '/companies/:companyName/add-networks',
  UserDetail: '/companies/:companyName/users/:userSid',
  ClientDetail: '/controllers/:controllerName/clients/:mac',
  SSIDEdit: '/controllers/:controllerName/config/ssids/:eid',
  DeviceDetail: '/controllers/:controllerName/devices/:id',
  DeviceEditLocation: '/controllers/:controllerName/devices/:id/edit',
  EditFirmwareUpdates: '/controllers/:controllerName/firmware-updates/edit',
  FloorPlanDetail: '/controllers/:controllerName/floorplans',
  IncidentDetail: '/controllers/:controllerName/incidents/:id',
  IncidentEditDetails: '/controllers/:controllerName/incidents/:id/edit-details',
  IncidentEditDuration: '/controllers/:controllerName/incidents/:id/edit-duration',
  IncidentCreate: '/controllers/:controllerName/incidents/new',
  LegacyNetworkInfo: '/controllers/:controllerName/legacy-ssids',
  EditLegacyNetworkInfo: '/controllers/:controllerName/legacy-ssids/edit',
  EditControllerMetadata: '/controllers/:controllerName/metadata/edit',
  EditNosUpgrade: '/controllers/:controllerName/nos-upgrade/edit',
  ISPDetails: '/controllers/:controllerName/plans/:planId',
  ISPDelete: '/controllers/:controllerName/plans/:planId/delete',
  ISPEdit: '/controllers/:controllerName/plans/:planId/edit',
  ISPCreate: '/controllers/:controllerName/plans/new',
  VPNClientCreate: '/controllers/:controllerName/vpn-clients/new',
  VPNServerEdit: '/controllers/:controllerName/vpn-server/edit',
  VPNServerDetailPage: '/controllers/:controllerName/vpn-servers',
  VPNClientDetailPage: '/controllers/:controllerName/vpn/:clientSid',
  NosVersionSummary: '/nos-versions/:nosId',
  NosVersionQuickView: '/nos-versions/view/:nosId',
} as const;